module.exports = {
  "cacheDir": "nextImageCache",
  "imageDir": "nextImageOutput",
  "sharpOptions": {
    "png": {
      "effort": 1
    },
    "webp": {
      "effort": 0
    },
    "avif": {
      "effort": 0
    }
  }
}